<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-plus"
        texto-titulo="Datos liquidacion"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <div class="col-12">
                    <div class="widget-content py-2 px-1 border-bottom">
                      <div class="text-left">
                        <h4 class="text-center">
                          <b class>{{ this.liquidacion.periodo }}</b> -
                          <b class="text-secondary">{{
                            this.liquidacion.tipo_liquidacion
                          }}</b>
                        </h4>
                      </div>
                    </div>
                    <div class="mt-2">
                      <div class="no-gutters row">
                        <div class="col-12 text-right mb-3">
                          <span class>
                            <b class="text-info">Emitida:</b>
                            {{ this.liquidacion.created_at | formatDate }}
                          </span>
                        </div>
                        <div class="col-sm-2 offset-sm-1">
                          <button
                            type="button"
                            @click="verLibroLey"
                            class="p-4 col-12 border-0 btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-dark"
                          >
                            <i
                              class="fa fa-book-open text-focus opacity-10 btn-icon-wrapper mb-2"
                            ></i>
                            <h6>Ver libro ley</h6>
                          </button>
                        </div>
                        <div class="col-sm-2">
                          <button
                            type="button"
                            @click="imprimirRecibos"
                            class="p-4 col-12 border-0 btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-alternate"
                          >
                            <i
                              class="fa fa-money-check-alt text-alternate opacity-10 btn-icon-wrapper mb-2"
                            ></i>
                            <h6>Ver recibos</h6>
                          </button>
                        </div>
                        <div class="col-sm-2">
                          <button
                            type="button"
                            @click="exportarRecibos"
                            class="p-4 col-12 border-0 btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-danger"
                          >
                            <i
                              class="fas fa-file-invoice text-danger opacity-10 btn-icon-wrapper mb-2"
                            ></i>
                            <h6>Exportar</h6>
                          </button>
                        </div>
                        <div class="col-sm-2">
                          <button
                            type="button"
                            @click="verTotales"
                            class="p-4 col-12 border-0 btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-success"
                          >
                            <i
                              class="fas fa-dollar-sign text-success opacity-10 btn-icon-wrapper mb-2"
                            ></i>
                            <h6>Imprimir totales</h6>
                          </button>
                        </div>
                        <div class="col-sm-2">
                          <button
                            type="button"
                            @click="imprimirForm931"
                            class="p-4 col-12 border-0 btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-primary"
                          >
                            <i
                              class="fas fa-file-download text-primary opacity-10 btn-icon-wrapper mb-2"
                            ></i>
                            <h6>Imprimir F.931</h6>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="liquidacion.totales">
                <div class="main-card mb-3 card">
                    <div class="card-header">
                        <ul class="nav nav-justified">
                            <li class="nav-item" v-for="(totales, seccion, n) in liquidacion.totales" :key="n">
                                <a data-toggle="tab" :href="'#'+seccion.replace(/[ ]|[.]|/g, '')" class="nav-link active show" v-if="n==0">{{seccion}}</a>
                                <a data-toggle="tab" :href="'#'+seccion.replace(/[ ]|[.]|/g, '')" class="nav-link" v-else>{{seccion}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <h5 class="text-focus font-weight-bold col-md-10">Resumen archivo: </h5>
                            <div class='col-12 offset-md-2 col-md-8 row tab-pane show' :class="(n==0) ? 'active' : ''" :id="seccion.replace(/[ ]|[.]|/g, '')" role="tabpanel" v-for="(totales, seccion, n) in liquidacion.totales" :key="n">
                              <div class="col-12">
                                <h4 class="text-focus font-weight-bold">
                                    {{ seccion }}
                                </h4>
                                <div class="row" v-for="(monto, concepto, n) in totales.conceptos" :key="n">
<!--                                    <template v-if="monto > 0">-->
                                      <div class="col-8">
                                        <b class="text-secondary">{{ concepto }}:</b>
                                      </div>
                                      <div class="col-4">
                                        <span class="font-weight-bold text-success">$ {{ monto | numFormat("0,0.00") }}</span>
                                      </div>
<!--                                    </template>-->
                                </div>
                                <br />
                                <div class="row">
                                  <div class="col-8">
                                    <b class>Haberes remunerativos:</b>
                                  </div>
                                  <div class="col-4">
                                    <span class="font-weight-bold text-primary">${{totales.total_remunerativo | numFormat("0,0.00")}}</span>
                                  </div>
                                  <div class="col-8">
                                    <b class>Haberes no remunerativos:</b>
                                  </div>
                                  <div class="col-4">
                                    <span class="font-weight-bold text-primary">${{totales.total_no_remunerativo | numFormat("0,0.00")}}</span>
                                  </div>
                                  <div class="col-8">
                                    <b class>Deducciones:</b>
                                  </div>
                                  <div class="col-4">
                                    <span class="font-weight-bold text-primary">${{totales.retenciones | numFormat("0,0.00")}}</span>
                                  </div>
                                  <hr />
                                  <div class="col-8">
                                    <h5 class="text-primary">
                                        <b>Total liquidado:</b>
                                    </h5>
                                  </div>
                                  <div class="col-4">
                                    <span class="font-weight-bold text-danger">${{totales.total_liquidado | numFormat("0,0.00")}}</span>
                                  </div>
                                </div>
                                <hr class="w-100" />
                                <div class="col-10 text-right">
                                  <button class="btn btn-primary" @click="imprimirSeccion(seccion)">Imprimir {{seccion}}</button>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="text-focus font-weight-bold col-md-10">Listado de recibos</h5>
                  <div class="row col-12">
                      <div class="col-md-6 col-12 form-group input-group">
                        <input type="text" class="form-control form-control-sm" placeholder="Buscar.." v-model="params.search"/>
                        <span class="input-group-append">
                          <button type="button" class="btn btn-sm btn-primary">
                            <i class="fas fa-search"></i>
                          </button>
                        </span>
                      </div>
                  </div>
                  <div class="row col-12 pt-3" style="max-height: 500px; overflow-y: auto" >
                    <div class="col-lg-12">
                      <div class="mb-3 col-12">
                        <div class="row">
                          <ul
                                  class="list-group list-group-flush mb-3"
                                  v-if="searching"
                                >
                                  <li class="list-group-item">
                                    <div class="skeleton">
                                      <div class="skeleton-author"></div>
                                      <div class="skeleton-content"></div>
                                      <div class="skeleton-content"></div>
                                    </div>
                                  </li>
                                  <li class="list-group-item">
                                    <div class="skeleton">
                                      <div class="skeleton-author"></div>
                                      <div class="skeleton-content"></div>
                                      <div class="skeleton-content"></div>
                                    </div>
                                  </li>
                          </ul>
                          <ul
                                  class="list-group list-group-flush mb-3"
                                  v-else-if="liquidacion.recibos == 0"
                                >
                                  <li class="list-group-item">
                                    <h5 class="text-center">
                                      No se encontraron resultados
                                    </h5>
                                  </li>
                          </ul>
                          <ul
                                  class="list-group list-group-flush mb-3 col-12"
                                  v-else
                                >
                                  <li
                                    class="list-group-item hoverable"
                                    v-for="(recibo, i) in recibosFiltrados"
                                    :key="i"
                                  >
                                    <div class="widget-content p-0">
                                      <div class="widget-content-wrapper row">
                                        <div class="widget-content-left col-11" @click="verRecibo(recibo)">
                                          <h5 class="widget-heading">
                                            <span class="text-primary">
                                              <span>{{ recibo.nombre }}</span>
                                            </span>
                                          </h5>
                                          <div
                                            class="widget-subheading opacity-10 row"
                                          >
                                            <span
                                              class="col-sm-auto col-12 row"
                                            >
                                              <span
                                                class="text-left col-sm-auto col-12"
                                              >
                                                Legajo N°
                                                <b class="text-alternate">{{
                                                  recibo.numero_legajo
                                                }}</b>
                                              </span>
                                              <span
                                                class="text-left col-sm-auto col-12"
                                              >
                                                <b class="text-alternate"
                                                  >{{ liquidacion.periodo }} -
                                                  {{ recibo.mensual_jornal }}</b
                                                >
                                              </span>
                                              <span
                                                class="text-left col-sm-auto col-12"
                                              >
                                                Seccion:
                                                <b class="text-alternate">{{
                                                  recibo.seccion
                                                }}</b>
                                              </span>
                                              <span
                                                class="ml-lg-3 text-left col-sm-auto col-12"
                                              >
                                                Neto:
                                                <b class="text-alternate">
                                                  $ {{ recibo.neto | numFormat('0,0.00')}}</b
                                                >
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                        <div class="col-1 float-right">
                                          <input type="checkbox" class="checkBoxRecibos" name="" :id="recibo.id">
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                          <button
                  @click="imprimirRecibosSeleccionados"
                  class="btn btn-info mr-3 col-2 mt-4 float-right"
                  type="button"
                >
                  Imprimir seleccionados
                </button>
                </div>
              </div>
              <div class="col-md-12 row d-flex flex-row-reverse mb-4">
                <button
                  @click="eliminarLiquidacion"
                  class="btn btn-danger col-1"
                  type="button"
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import axios from "axios";
import Swal from "sweetalert2";
import Liquidacion from "@/models/liquidacion";
export default {
  name: "VerLiquidacion",
  components: {
    TituloComponente,
  },
  data() {
    return {
      liquidacion: new Liquidacion(null, "", "", ""),
      loading: false,
      enviado: false,
      searching: false,
      params:{
        search: "",
        liquidacion_id: null
      },
    };
  },
  created() {
    this.liquidacion.id = this.$route.params.id;
    this.getLiquidacion();
  },

  computed: {
    recibosFiltrados: function () {
      if(this.liquidacion.recibos){
        let filtro = [...this.liquidacion.recibos];
        filtro.sort(function (a, b) {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            // a must be equal to b
            return 0;
          })
        if (this.params.search == "") {
          return filtro;
        }
        return filtro

        .filter(
          function (item) {
            return item.nombre
              .toUpperCase()
              .includes(this.params.search.toUpperCase());
          }.bind(this)
        );
      }
      return [];
    },
  },
  methods: {
    getLiquidacion() {
      this.loading = true;
      axios
        .get("liquidacion/" + this.liquidacion.id)
        .then((res) => {
          if (res.data.success) {
            this.liquidacion = res.data.liquidacion;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Liquidacion.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    eliminarLiquidacion() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar la liquidacion del periodo ${this.liquidacion.periodo} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("liquidacion/" + this.liquidacion.id)
            .then(() => {
              Swal.fire("Eliminado", `Se ha eliminado con éxito.`, "success");
              this.$router.push({ name: "ListarLiquidaciones" });
            })
            .catch((err) => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
    verRecibo(recibo) {
      Swal.fire({
        title: "¿Que desea hacer?",
        showCancelButton: true,
        confirmButtonColor: "#794c8a",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Imprimir",
        cancelButtonText: "Editar",
      }).then((result) => {
        console.log(result);
        if(result.dismiss == "cancel"){
          this.loading = true;
          this.$router.push({ name: "EditarRecibo", params: { id: recibo.id } });
          console.log("hace cancel");
        }
        if (result.isConfirmed) {
          axios.get("recibos/imprimir/" + recibo.id, {
            responseType: "arraybuffer",
          }).then((res) => {
            let blob = new Blob([res.data], { type: "application/pdf" }),
              url = window.URL.createObjectURL(blob);
            window.open(url);
            this.loading = false;
          }).catch((err) => console.log(err)).finally(() => (this.loading = false));
        }
      });
    },
    imprimirRecibos() {
      this.loading = true;
      axios
        .get("liquidacion/recibos/" + this.liquidacion.id, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
          this.loading = false;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    exportarRecibos() {

      this.loading = true;
      axios
        .get("liquidacion/exportar-recibos/" + this.liquidacion.id, )
        .then((res) => {
          let exportName = `${this.liquidacion.institucion.razon_social}_${this.liquidacion.periodo}_${this.liquidacion.tipo_liquidacion}`
          let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(res.data));
          let downloadAnchorNode = document.createElement('a');
          downloadAnchorNode.setAttribute("href",     dataStr);
          downloadAnchorNode.setAttribute("download", exportName + ".json");
          document.body.appendChild(downloadAnchorNode); // required for firefox
          downloadAnchorNode.click();
          downloadAnchorNode.remove();
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    verTotales() {
      this.loading = true;
      axios
        .get("liquidacion/detalle-liquidacion/" + this.liquidacion.id, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
          this.loading = false;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    verLibroLey() {
      this.loading = true;
      axios
        .get("liquidacion/libro-ley/" + this.liquidacion.id, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
          this.loading = false;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    imprimirForm931(){
      window.location.href=axios.defaults.baseURL+"/f931/txt/" + this.liquidacion.id;

    },
    imprimirSeccion(seccion){
      console.log(this.liquidacion)
      this.loading = true;
      axios
        .get("imprimir/recibo/seccion?liquidacionid="+this.liquidacion.id+"&seccion="+seccion ,{
          responseType: "arraybuffer",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
          window.open(url);
          this.loading = false;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    imprimirRecibosSeleccionados(){
      let ids=[];
      let input = document.querySelectorAll(".checkBoxRecibos:checked");
      console.log(input)
      if(input.length > 0){
        input.forEach((e) => {
            ids.push(e.getAttribute('id'));
          e.checked=false;
        })
        //document.querySelectorAll(".checkBoxRecibos").checked = false;
        axios.post("recibos/imprimir/seleccionados", {params: ids}, {
          responseType: "arraybuffer",
        }).then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
          window.open(url);
          this.loading = false;
        }).catch((err) => console.log(err)).finally(() => (this.loading = false));
      }else{
        Swal.fire({
          icon: "warning",
          title: "Oopss..",
          text: `No ha seleccionado ningun recibo para imprimir.`,
        });
      }
    }
  },
};
</script>
